import { render, staticRenderFns } from "./MyWeek.vue?vue&type=template&id=a118bf8c&"
import script from "./MyWeek.vue?vue&type=script&lang=js&"
export * from "./MyWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports